import React from "react";
import { motion } from "framer-motion";
import NavbarComponent from "../component/NavbarComponent";

const CBPpage = () => {
  return (
    <React.Fragment>
      <NavbarComponent />

      <div className="min-h-screen text-lg font-bold p-3  mt-4  lg:pl-20 md:pl-20  lg:pr-20 md:pr-20">
        <div className="grid md:grid-cols-7 gap-10">
          <div className="grid gap-4  md:grid-cols-5 grid-cols-2 pt-5 md:col-span-5">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
            >
              <div className="flex flex-col justify-center">
                <div className="flex justify-center">
                  <a
                    href="../assets/Report for PRO Day 1.pdf"
                    target="blank"
                    className="text-black font-semibold"
                  >
                    <img
                      src="../assets/pdf.png"
                      className="h-20 w-20"
                      alt="pdf"
                    />
                  </a>
                </div>
                <h1 className="text-sm p-1">Report for PRO Day 1</h1>
              </div>
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
            >
              <div className="flex flex-col justify-center">
                <div className="flex justify-center">
                  <a
                    href="../assets/Report for PRO Day1.pdf"
                    target="blank"
                    className="text-black font-semibold"
                  >
                    <img
                      src="../assets/pdf.png"
                      className="h-20 w-20"
                      alt="pdf"
                    />
                  </a>
                </div>
                <h1 className="text-sm p-1">Report for PRO Day1</h1>
              </div>
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
            >
              <div className="flex flex-col justify-center">
                <div className="flex justify-center">
                  <a
                    href="../assets/Report for PRO Day 2.pdf"
                    target="blank"
                    className="text-black font-semibold"
                  >
                    <img
                      src="../assets/pdf.png"
                      className="h-20 w-20"
                      alt="pdf"
                    />
                  </a>
                </div>
                <h1 className="text-sm p-1">Report for PRO Day 2</h1>
              </div>
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
            >
              <div className="flex flex-col justify-center">
                <div className="flex justify-center">
                  <a
                    href="../assets/Report for PRO Day2.pdf"
                    target="blank"
                    className="text-black font-semibold"
                  >
                    <img
                      src="../assets/pdf.png"
                      className="h-20 w-20"
                      alt="pdf"
                    />
                  </a>
                </div>
                <h1 className="text-sm p-1">Report for PRO Day2</h1>
              </div>
            </motion.div>
          </div>
          <div className="md:col-span-2">
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className=""
            >
              <div className=" text-center pb-5">
                <motion.div
                  whileInView={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: 100 }}
                  transition={{ duration: 0.75, delay: 0.75 }}
                  viewport={{ once: true }}
                  className="bg-[#fb8500] py-2 text-center font-bold text-white mt-5 w-80 mx-auto rounded-lg"
                >
                  <span>Video Links</span>
                </motion.div>
              </div>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.55, delay: 0.55 }}
                viewport={{ once: true }}
                className="mb-4 text-sm text-center"
              >
                <a
                  href="https://drive.google.com/drive/folders/15P6TzDMqWSCThrsUiekVwttOE133PAXS?usp=drive_link"
                  target="blank"
                  className="text-black"
                >
                  Photo & video link for 11 May 2023
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.65, delay: 0.65 }}
                viewport={{ once: true }}
                className="mb-4 text-sm text-center"
              >
                <a
                  href="https://drive.google.com/drive/folders/1FixFDbMmUEMD-2qL4HbasfjTdlnUjMM5?usp=drive_link"
                  target="blank"
                  className="text-black"
                >
                  Photo & Video link for 12 May 2023
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className="mb-4 text-sm text-center"
              >
                <a
                  href="https://drive.google.com/drive/folders/1z3MCIWBS_LeKWTfprnEJdy13Yv3N-0Uw?usp=drive_link"
                  target="blank"
                  className="text-black"
                >
                  Photo link for 17 June 2023
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.85, delay: 0.85 }}
                viewport={{ once: true }}
                className="mb-4 text-sm text-center"
              >
                <a
                  href="https://drive.google.com/drive/folders/1ewknj5GtRTCu3k1s68XLv7u-qoLo2KoH?usp=drive_link"
                  target="blank"
                  className="text-black"
                >
                  Photo Link for 18 June 2023
                </a>
              </motion.p>

              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.85, delay: 0.85 }}
                viewport={{ once: true }}
                className="mb-4 text-sm text-center"
              >
                <a
                  href="https://drive.google.com/drive/folders/1fHcAlPIe8vksqSin03aAQlBqhduQLOYd?usp=drive_link"
                  target="blank"
                  className="text-black"
                >
                  Video Link for 18 June 2023
                </a>
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default CBPpage;
